export default __webpack_public_path__ + "static/media/DEX.fd22d14a.png";